import { cn } from '../lib/utils'

// Self-drawing WeTook "W" mark — the shared loading screen across apps. Pure CSS
// stroke animation (no GSAP); the stroke is `currentColor`, so it reads correctly
// on any surface (near-black on light, near-white on dark). Mirrors the landing's
// draw-path loader. The W is a single outline path, which is what makes the
// "drawing" animation possible (filled marks can't stroke-draw the same way).
const W_PATH =
  'M160.82,142.74l-.09-38.62-38.64,38.55-26.5.08-.22-38.88-38.9,38.82-26.45-.02.05-83.12c1.88-2.58,4.09-4.01,6.22-6.13l33.35-33.26c1.4-1.94,2.86-3.37,4.76-5.03l24.13-.03.13,41.19,41.24-41.21,23.91.02.1,41.15,41.19-41.15,24-.05.03,83.21-44.38,44.4-23.93.07Z'

export function LogoLoader({ className, caption }: { className?: string; caption?: string }) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-6', className)}>
      <svg
        viewBox="0 0 259.15 157.81"
        fill="none"
        aria-hidden="true"
        className="wt-logo-loader h-auto w-[min(150px,42vw)] overflow-visible text-foreground"
      >
        <path pathLength={1} d={W_PATH} />
      </svg>
      {caption && <p className="text-sm font-medium text-muted-foreground">{caption}</p>}
      <style>{`
        .wt-logo-loader path {
          fill: none;
          stroke: currentColor;
          stroke-width: 6;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 1;
          stroke-dashoffset: 1;
          animation: wt-logo-draw 2.4s ease-in-out infinite;
        }
        @keyframes wt-logo-draw {
          0%   { stroke-dashoffset: 1; }
          45%  { stroke-dashoffset: 0; }
          55%  { stroke-dashoffset: 0; }
          100% { stroke-dashoffset: -1; }
        }
        @media (prefers-reduced-motion: reduce) {
          .wt-logo-loader path { animation: none; stroke-dashoffset: 0; }
        }
      `}</style>
    </div>
  )
}
